import { connect } from 'formik';
import { Component } from 'react';

import { Radio } from 'hb-react/shared/components/formik/components/inputs';

import style from './index.module.scss';

class Simple extends Component {
  handleRecurringChange = (value) => {
    const { formik } = this.props;

    if (value === 'true') {
      formik.setFieldValue('donation_order[recurring_payment_enabled]', 'true');
      formik.setFieldValue('donation_order[periodicity]', 'month');
    } else {
      formik.setFieldValue(
        'donation_order[recurring_payment_enabled]',
        'false',
      );
      formik.setFieldValue('donation_order[periodicity]', 'three_months');
    }
  };

  render() {
    return (
      <div className={style.component}>
        <Radio
          name="donation_order[monthly_payment]"
          type="toggle"
          validate={{
            required: true,
          }}
          inputs={[
            {
              value: 'false',
              label: s__('Donations|Give once'),
            },
            {
              value: 'true',
              label: s__('Donations|Give monthly'),
            },
          ]}
          onChange={this.handleRecurringChange}
        />
      </div>
    );
  }
}

export default connect(Simple);
